<div class="flex-shrink-0 p-1 border border-black-50 shadow-sm rounded-3" *ngIf="mobileNavToggled()">
  <ul class="list-unstyled ps-0">
    <ng-container *ngFor="let item of navDataDisplay">
      <li class="mb-1" *ngIf="item.parentidx && hasPermission(item.name)">
        <ng-container *ngIf="item.parentidx == 'tk'">
          <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#submenu01-collapse" aria-expanded="false">
            {{item.label}}
          </button>
          <div class="collapse" id="submenu01-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <ng-container *ngFor="let subItem of item.subItems">
                <li *ngIf="hasPermission(subItem.name)">
                  <a [routerLink]="item.routeLink + '/'+ subItem.routeLink" class="link-body-emphasis d-inline-flex text-decoration-none rounded" (click)="toggleMobileMenu()">{{subItem.label}}</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <ng-container *ngIf="item.parentidx == 'bqc-bcn'">
          <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#submenu02-collapse" aria-expanded="false">
            {{item.label}}
          </button>
          <div class="collapse" id="submenu02-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <ng-container *ngFor="let subItem of item.subItems">
                <li *ngIf="hasPermission(subItem.name)">
                  <a [routerLink]="item.routeLink + '/'+ subItem.routeLink" class="link-body-emphasis d-inline-flex text-decoration-none rounded" (click)="toggleMobileMenu()">{{subItem.label}}</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <ng-container *ngIf="item.parentidx == 'bpt-bcn-k'">
          <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#submenu03-collapse" aria-expanded="false">
            {{item.label}}
          </button>
          <div class="collapse" id="submenu03-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <ng-container *ngFor="let subItem of item.subItems">
                <li *ngIf="hasPermission(subItem.name)">
                  <a [routerLink]="item.routeLink + '/'+ subItem.routeLink" class="link-body-emphasis d-inline-flex text-decoration-none rounded" (click)="toggleMobileMenu()">{{subItem.label}}</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <ng-container *ngIf="item.parentidx == 'bt-clb'">
          <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#submenu04-collapse" aria-expanded="false">
            {{item.label}}
          </button>
          <div class="collapse" id="submenu04-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <ng-container *ngFor="let subItem of item.subItems">
                <li *ngIf="hasPermission(subItem.name)">
                  <a [routerLink]="item.routeLink + '/'+ subItem.routeLink" class="link-body-emphasis d-inline-flex text-decoration-none rounded" (click)="toggleMobileMenu()">{{subItem.label}}</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <ng-container *ngIf="item.parentidx == 'bt-clb'">
          <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#submenu05-collapse" aria-expanded="false">
            {{item.label}}
          </button>
          <div class="collapse" id="submenu05-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <ng-container *ngFor="let subItem of item.subItems">
                <li *ngIf="hasPermission(subItem.name)">
                  <a [routerLink]="item.routeLink + '/'+ subItem.routeLink" class="link-body-emphasis d-inline-flex text-decoration-none rounded" (click)="toggleMobileMenu()">{{subItem.label}}</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </li>
      <li *ngIf="!item.parentidx && hasPermission(item.name)">
        <button class="btn d-inline-flex align-items-center rounded border-0" [routerLink]="item.routeLink" (click)="toggleMobileMenu()">
          {{item.label}}
        </button>
      </li>
    </ng-container>
  </ul>
   </div>
